import { render } from "./BankDetailsPopup.vue?vue&type=template&id=6d50f326&scoped=true"
import script from "./BankDetailsPopup.vue?vue&type=script&lang=js"
export * from "./BankDetailsPopup.vue?vue&type=script&lang=js"

import "./BankDetailsPopup.vue?vue&type=style&index=0&id=6d50f326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d50f326"]])

export default __exports__